export const ALERTS_SLICE = "alerts";
